export default __webpack_public_path__ + "static/media/pokeball.e57f7ae6.svg";